"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactResizeDetector = require("react-resize-detector");
var _components = require("@folio/stripes/components");
var _eventCodes = require("../../constants/eventCodes");
var _selectorSafe = _interopRequireDefault(require("../../utils/selectorSafe"));
var _useTypedownToggle = _interopRequireDefault(require("./useTypedownToggle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useTypedown = name => {
  // SEARCHFIELD COMPONENT
  const searchFieldComponent = document.getElementById(`typedown-searchField-${(0, _selectorSafe.default)(name)}`);

  // SET UP REFS
  const listRef = (0, _react.useRef)();
  const triggerRef = (0, _react.useRef)();
  const overlayRef = (0, _react.useRef)();
  const footerRef = (0, _react.useRef)();
  const footer = document.getElementById(`typedown-footer-${(0, _selectorSafe.default)(name)}`);
  // Add an event listener to the footer, so that we can control tab behaviour between footer elements

  if (footer && footer.getAttribute('hasListener') !== 'true') {
    footer.addEventListener('keydown', e => {
      // We want special behaviour on tab
      if (e.code === _eventCodes.TAB) {
        // Prevent the default behaviour
        e.preventDefault();
        const focusFunc = e.shiftKey ? _components.getPreviousFocusable : _components.getNextFocusable;
        const elem = focusFunc(footerRef.current, true, true, false, true);
        if (elem) {
          // Focus on next focusable element
          elem.focus();
        } else if (e.shiftKey) {
          // We are at the beginning of the list, refocus on search bar
          searchFieldComponent.focus();
        } else {
          // We are at the end of the list, move onto next focusable element in page
          (0, _components.getNextFocusable)(searchFieldComponent, false).focus();
        }
      }
    });
    footer.setAttribute('hasListener', 'true');
  }

  // SET UP HANDLERS
  const searchFieldKeyDownHandler = e => {
    if (e.code === _eventCodes.UP_ARROW) {
      const elem = (0, _components.getLastFocusable)(listRef.current, true, true);
      if (elem) {
        elem.focus();
      }
    }
    if (e.code === _eventCodes.DOWN_ARROW) {
      const elem = (0, _components.getFirstFocusable)(listRef.current, true, true);
      if (elem) {
        elem.focus();
      }
    }

    // Tab key (But not while shifting)
    if (e.code === _eventCodes.TAB && !e.shiftKey) {
      e.preventDefault();
      // If we have focusable elements in the footer, then focus on them, else unfocus searchbar
      const elem = (0, _components.getNextFocusable)(footerRef.current, true, true, true, true);
      if (elem) {
        elem.focus();
      } else {
        (0, _components.getNextFocusable)(searchFieldComponent, false).focus();
      }
    }
  };
  const listKeyDownHandler = e => {
    if (e.code === _eventCodes.DOWN_ARROW) {
      const elem = (0, _components.getNextFocusable)(listRef.current, true, true);
      elem.focus();
    }
    if (e.code === _eventCodes.UP_ARROW) {
      const elem = (0, _components.getPreviousFocusable)(listRef.current, true, true);
      elem.focus();
    }
    if (e.code === _eventCodes.TAB) {
      e.preventDefault();
      let elem;
      if (!e.shiftKey && !footerRef.current) {
        elem = (0, _components.getNextFocusable)(searchFieldComponent, false);
      } else if (!e.shiftKey) {
        elem = (0, _components.getNextFocusable)(footerRef.current, true, true, true, true);
      } else {
        elem = searchFieldComponent;
      }
      elem.focus();
    }
  };
  const handleNextFocus = () => (0, _components.getNextFocusable)(searchFieldComponent, false).focus();

  // SET UP VARIABLES
  const {
    open
  } = (0, _useTypedownToggle.default)(name);

  // RESIZE STUFF
  const {
    width: searchWidth,
    ref: resizeRef
  } = (0, _reactResizeDetector.useResizeDetector)();

  // OVERLAY PORTAL
  const portal = document.getElementById('OverlayContainer');
  return {
    refs: {
      listRef,
      triggerRef,
      overlayRef,
      footerRef
    },
    handlers: {
      handleNextFocus,
      listKeyDownHandler,
      searchFieldKeyDownHandler
    },
    variables: {
      open,
      portal,
      resizeRef,
      searchWidth
    }
  };
};
var _default = exports.default = useTypedown;